/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { BrandColors } from '@blend/enterprise-components';
import { Box } from 'grommet';
import styled from 'styled-components';

import { getPersona, isSidebarImplementedPersona } from 'blb-persona/index';
import { MeContext } from 'blb-contexts/Me';
import { allRoutesConfigurations } from './routeConfiguration';

const SidebarWrapper = styled(Box)`
  background-color: ${BrandColors.NIGHT};
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100vh;
  justify-content: space-between;
  padding: 20px;
`;

export namespace SidebarContainer {
  export interface Props {}
}

export const SidebarContainer: React.FC<SidebarContainer.Props> = ({}) => {
  const me = useContext(MeContext)!;
  const persona = getPersona(me.principalType);

  const renderSidebar = (SideBarContent: React.FC | null): React.ReactElement | null => {
    if (SideBarContent) {
      if (isSidebarImplementedPersona(persona)) {
        return persona.getSidebar();
      }

      return (
        <SidebarWrapper>
          <SideBarContent />
        </SidebarWrapper>
      );
    }
    return null;
  };

  return (
    <Switch>
      {allRoutesConfigurations.map(({ path, SideBarContent }) => (
        <Route exact key={path} path={path}>
          {renderSidebar(SideBarContent)}
        </Route>
      ))}
    </Switch>
  );
};
